export const emptyColor = '#e2e9f0';
export const colorsPallete = [
  '#FBCB21',
  '#6eca55',
  '#FB2182',
  '#AAD43F',
  '#902E93',
  '#BF3478',
  '#4661C3',
  '#EBB96D',
  '#7633E1',
  '#815E7B',
  '#BE2029',
  '#E67674'
];
export const colorsPalleteSecond = [
  '#008DBD',
  '#00CBF3',
  '#00BBBD',
  '#D945B3',
  '#BF3478',
  '#4661C3',
  '#EBB96D',
  '#7633E1',
  '#815E7B',
  '#BE2029',
  '#E67674'
];

export const colors = (
  index: number,
  isDataProvided: boolean,
  pallete = 'primary'
) => {
  if (!isDataProvided) return emptyColor;
  if (pallete === 'secondary') {
    const choosenColor = colorsPalleteSecond[index];
    if (choosenColor) return choosenColor;

    return emptyColor;
  }
  const choosenColor = colorsPallete[index];
  if (choosenColor) return choosenColor;

  return emptyColor;
};

export const newPalette = [
  '#ba4977',
  '#9c5ba3',
  '#6470bc',
  '#0080bc',
  '#0089a7',
  '#008d88',
  '#007561',
  '#008f59',
  '#00a84d',
  '#5bc040',
  '#a4d636',
  '#d5d41b',
  '#f37540',
  '#f15961',
  '#de4a82',
  '#c52260'
];

export const opaicNewPallet = [
  'rgba(89, 137, 197, 0.4 )',
  'rgba(101, 117, 181, 0.4 )',
  'rgba(145, 84, 138, 0.4 )',
  'rgba(170, 95, 120, 0.4 )',
  'rgba(218, 117, 66, 0.4 )',
  'rgba(240, 128, 6, 0.4 )',
  'rgba(170, 95, 120, 0.4 )',
  'rgba(110, 98, 165, 0.4 )',
  'rgba(89, 137, 197, 0.4 )',
  'rgba(34, 169, 224, 0.4 )',
  'rgba(218, 117, 66, 0.4 )',
  'rgba(194, 106, 98, 0.4 )'
];

export const policyColors: any = {
  existing: '#f37540',
  recommended: '#1b84ab',
  cash: '#b61717',
  inflation: '#37712e',
  sterlingEquityRisk: '#60318a',
  sterlingCautious: '#787878',
  sterlingSteadyGrowth: '#221f47',
  sterlingBalancedAsset: '#9bc31d'
};

export const adviserCharges: any = {
  net_value: '#1b84ab',
  advisor_charges: '#1b2d5a',
  product_charges: '#ba4977',
  annualised_withdrawals: '#bbd749',
  annualised_contributions: '#65459b'
};

export const policyColorsArray = ['#da7542', '#25acc7', '#b61717', '#37712e'];

export const pastPerformancePalette = [
  '#1b2d5a',
  '#b71f2a',
  '#235126',
  '#f37540',
  '#ba4977',
  '#1b84ab',
  '#65459b',
  '#a4d636',
  '#2562b5',
  '#d78dcb',
  '#5bc040',
  '#de4a82',
  '#0086d2',
  '#eae837',
  '#538340',
  '#6470bc',
  '#f15961',
  '#00a84d',
  '#717ee0',
  '#9c5ba3',
  '#2bab97',
  '#5f0323',
  '#fac354',
  '#16afe5',
  '#007561',
  '#c52260',
  '#562365'
];

export const riskRatingColors = [
  '#22A9E0',
  '#489AD3',
  '#5989C5',
  '#6575B5',
  '#6E62A5',
  '#91548A',
  '#AA5F78',
  '#C26A62',
  '#DA7542',
  '#F08006'
];
